import React, { ReactNode } from 'react'
import { useStyles } from './styles'
import { Box } from '@mui/material'

interface ITableRoot {
  children: ReactNode
}

const TableRoot: React.FC<ITableRoot> = ({ children }) => {
  const classes = useStyles()

  return (
    <Box className={classes.root}>
      {children}
    </Box>
  )
}

export default TableRoot
